class AlpProductInfo extends HTMLElement {
  constructor() {
    super();
    this.currentProductId = null;
    this.variantId = null;
    this.overlayBlockerEl = null;
    this.variantsSelectorEl = null;
    this.cartUpdateUnsubscriber = null;
    this.addToCartButton = null;
    this.priceEl = null;
    this.productStockLabelEl = null;
    this.addToCartFormEl = null;
  }

  onVariantSelected(evt) {
    console.log('onVariantSelected: ', evt.detail);
    evt.detail.id && this.loadProductData(evt.detail.id);
  }

  updateURL(variantId) {
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${variantId}`);
  }

  updateQuantity(qty) {
    const qtySelectEl = this.querySelector(`alp-product-quantity-selector`);
    if (qtySelectEl) {
      qtySelectEl.setAttribute('data-qty', qty);
      qtySelectEl.setAttribute('data-disabled', `${qty === 0}`);
    }
  }

  setButtonAddCart(qty) {
    if (!this.addToCartButton) {
      return;
    }
    const disabledClass = this.addToCartButton.dataset.disableClass;
    this.addToCartButton.classList.add(disabledClass);
    qty && this.addToCartButton.classList.remove(disabledClass);
  }

  updatePrice(variant) {
    if (this.priceEl) {
      this.priceEl.setAttribute('data-price', variant.price);
      this.priceEl.setAttribute('data-compare-at-price', variant.compare_at_price);
    }
  }

  updateStockLabel(variant) {
    if (this.productStockLabelEl) {
      const oosClass = this.productStockLabelEl.dataset.oosClass;

      if (variant.available) {
        this.productStockLabelEl.innerText = this.productStockLabelEl.dataset.inStockLabel;
        this.productStockLabelEl.classList.remove(oosClass);
      } else {
        this.productStockLabelEl.innerText = this.productStockLabelEl.dataset.outOfStockLabel;
        this.productStockLabelEl.classList.add(oosClass);
      }
    }
  }

  updateValidationFormProductId(pId) {
    const containerEl = this.querySelector(`alp-product-form[data-section-id="${this.dataset.section}"]`);
    if (containerEl) {
      const input = containerEl.querySelector('input.product-variant-id');
      input && (input.value = pId);
    }
  }

  showErrorMessage(message) {
    const errorMessageWrapper = this.querySelector(`div[data-product-form-id="${this.dataset.productFormId}"].error-message-wrapper`);

    if (errorMessageWrapper) {
      const errorMessageEl = errorMessageWrapper.querySelector('.error-message');
      errorMessageEl.textContent = message;
      if (message) {
        errorMessageWrapper.classList.remove('hidden');
      } else {
        errorMessageWrapper.classList.add('hidden');
      }
    }
  }

  setLoading(state) {
    this.overlayBlockerEl && state && this.overlayBlockerEl.classList.remove('hidden');
    this.overlayBlockerEl && !state && this.overlayBlockerEl.classList.add('hidden');
  }

  loadProductData(pId) {
    this.setLoading(true);
    this.showErrorMessage();
    const endpoint = `${this.dataset.url}?variant=${pId}&section_id=${this.dataset.section}`

    // Load
    fetch(endpoint)
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const productVariantDataScriptEl = html.querySelector(`script#product-${this.currentProductId}-selected_or_first_available_variant`);

        if (productVariantDataScriptEl) {
          let variantData = null;
          try {
            variantData = JSON.parse(productVariantDataScriptEl.textContent);
            variantData = {
              ...variantData.data,
              ...variantData.formatted_data,
            }
          } catch (e) {
            throw new Error('error while parsing product data');
          }

          if (variantData) {
            const qty = variantData.inventory_quantity > MAX_QTY_SELECTABLE ? MAX_QTY_SELECTABLE : variantData.inventory_quantity
            this.updateURL(pId);
            this.updateQuantity(qty);
            this.setButtonAddCart(qty);
            this.updatePrice(variantData);
            this.updateStockLabel(variantData);
            this.updateValidationFormProductId(pId);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.setLoading(false);
      });
      // end load //*/
  }

  init() {
    this.currentProductId = this.dataset.productId;
    this.variantsSelectorEl = this.querySelector('alp-product-variants-selector');
    this.overlayBlockerEl = document.querySelector('.overlay-blocker');
    this.addToCartButton = this.querySelector('.btn-add-to-cart');
    this.priceEl = this.querySelector('alp-price');
    this.productStockLabelEl = this.querySelector('.product-stock-label');
    this.addToCartFormEl = this.querySelector('alp-product-form');

    if (this.variantsSelectorEl) {
      this.variantsSelectorEl.addEventListener(PUB_SUB_EVENTS.variantChange, this.onVariantSelected.bind(this));
    }

    if (this.addToCartFormEl) {
      this.addToCartFormEl.addEventListener(PUB_SUB_EVENTS.cartAddError, ({ detail }) => {
        this.showErrorMessage(detail.message);
      })
    }
    this.setLoading(false);
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 250);
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
}

class AlpPrice extends HTMLElement {
  constructor() {
    super();
  }

  priceWithCurrency(price, currency, locale) {
    if (!price) return '';
    if (locale === 'en') {
      return `${currency} ${price}`;
    }

    return `${price.replace('\'', ' ').replace('.', ',')} ${currency}`;
  }

  render() {
    const locale = this.dataset.locale || window.SHOP.locale;
    const currencySymbol = this.dataset.currencySymbol || window.SHOP.currency;
    const price = this.priceWithCurrency(this.dataset.price, currencySymbol, locale);
    const compareAtPrice = this.priceWithCurrency(this.dataset.compareAtPrice, currencySymbol, locale);

    const priceEl = this.querySelector('.price');
    const priceCompareEl = this.querySelector('.price-compare');
    const priceCompareElWrapper = this.querySelector('.compare-at-price-wrapper');

    priceEl && (priceEl.innerText = price);
    if (compareAtPrice && priceCompareEl) {
      priceCompareEl.innerText = compareAtPrice;
      priceCompareElWrapper && priceCompareElWrapper.classList.remove('hidden');
    } else {
      priceCompareElWrapper && priceCompareElWrapper.classList.add('hidden');
    }
  }

  static get observedAttributes() { // (3)
    return ['data-price', 'data-compare-at-price', 'data-locale', 'data-currency-symbol'];
  }

  attributeChangedCallback(name, oldValue, newValue) { // (4)
    this.render();
  }


  connectedCallback() {
    setTimeout(() => {
      this.render();
    }, 100);
  }
}

class AlpVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.options = [];
  }

  onSelectVariant(evt) {
    this.dispatchEvent(new CustomEvent(PUB_SUB_EVENTS.variantChange, {
      detail: {id: evt.target.value}
    }));
  }

  init() {
    this.options = this.querySelectorAll('input[type="radio"]');
    this.options.forEach((el) => {
      el.addEventListener('change', this.onSelectVariant.bind(this));
    });
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 100);
  }

  disconnectedCallback() {
    if (this.options) {
      this.options.forEach((el) => {
        el.removeEventListener('change', this.onSelectVariant.bind(this));
      });
    }
  }
}

class AlpQuantitySelector extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;
  constructor() {
    super();
    this.DISABLED_CLASS = 'pointer-events-none';
    this.inputSelect = null;
    this.inputSelectWrapper = null;
    this.inputQtyEl = null;
  }

  enableSelect(state) {
    if (state) {
      this.inputSelectWrapper.classList.remove(this.DISABLED_CLASS);
      this.inputSelect.classList.remove(this.DISABLED_CLASS);
    } else {
      this.inputSelectWrapper.classList.add(this.DISABLED_CLASS);
      this.inputSelect.classList.add(this.DISABLED_CLASS);
    }
  }

  render() {
    if (!this.inputSelect) {
      return;
    }
    const qty = parseInt(this.dataset.qty, 10) || 1;
    const disabled = this.dataset.disabled.toLowerCase() === 'true';
    const options = [new Option('1', '1')];

    // Reset select
    this.inputSelect.options.length = 0;
    this.enableSelect(!disabled);

    if (!disabled) {
      const resolveQty = qty < MAX_QTY_SELECTABLE ? MAX_QTY_SELECTABLE : qty;
      for (let i = 2; i <= resolveQty; i++) {
        options.push(new Option(`${i}`, `${i}`));
      }
    }

    options.forEach((opt) => {
      this.inputSelect.appendChild(opt);
    });
  }

  onInputChange(event) {
    if (this.inputQtyEl) {
      this.inputQtyEl.value = event.target.value;
    }

    this.dispatchEvent(new CustomEvent(PUB_SUB_EVENTS.quantityChanged, {
      detail: {dataset: this.dataset, value: event.target.value}
    }));
  }

  init() {
    this.inputSelectWrapper = this.querySelector('.select-wrapper');
    this.inputSelect = this.querySelector('select');
    this.inputQtyEl = this.querySelector('.input-qty');
    this.inputSelect.addEventListener('change', this.onInputChange.bind(this));
  }

  setValue(value) {
    if (this.inputSelect) {
      Array.from(this.inputSelect.options).forEach((option) => {
        if (option.value === value) {
          this.inputSelect.value = value;
          this.inputQtyEl.value = value;
        }
      })
    }
  }

  static get observedAttributes() {
    return ['data-qty', 'data-disabled'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.render();
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 100);
  }
}

/*
* Product form add to cart
*/
class AlpProductForm extends HTMLElement {
  constructor() {
    super();

    this.formEl = null;
    this.cartEl = null;
    this.submitButtonEl = null;
    this.productFormId = null;
  }

  init() {
    this.formEl = this.querySelector('form');
    this.formEl.querySelector('[name=id]').disabled = false;
    this.formEl.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.productFormId = this.dataset.productFormId;

    this.cartEl = document.querySelector('cart-drawer');
    this.submitButtonEl = this.querySelector(`#${this.dataset.buttonSubmitId}`);
  }

  setLoading(state) {
    if (this.submitButtonEl) {
      const layer = this.submitButtonEl.querySelector('.overlay-spinner-loading');
      layer && state && layer.classList.remove('hidden');
      layer && !state && layer.classList.add('hidden');
    }
  }

  getProductQuantity() {
    if (this.productFormId) {
      const selector = `input[type="hidden"][form="${this.productFormId}"]`;
      const input = document.querySelector(selector);

      if (input) {
        return input.value;
      }
    }

    return 0;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    const config = AlpHelpers.fetchConfig('javascript');
    const formData = new FormData(this.formEl);
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    this.setLoading(true);
    this.dispatchErrorEvent();

    if (this.cartEl) {
      formData.append(
        'sections',
        this.cartEl.getSectionsToRender().map((section) => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      const qty = this.getProductQuantity();
      qty && formData.append('quantity', `${qty}`);
      this.cartEl.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.dispatchErrorEvent(response.description);
        } else {
          this.cartEl && this.cartEl.renderContents(response, () => {
            this.init();
          });
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  dispatchErrorEvent(message = false) {
    this.dispatchEvent( new CustomEvent(PUB_SUB_EVENTS.cartAddError, {detail: { message }}))
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 100);
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  render(sectionEl) {
    // Dataset
    const { currentProductId, maxItems, recommendationsProductsCount } = sectionEl.dataset;
    const count = parseInt(recommendationsProductsCount, 10);

    if (count === 0) {
      // Random products
      const allProductsEl = sectionEl.querySelectorAll('a[data-name="card"]');

      if (allProductsEl.length) {
        const productsEl = Array.from(allProductsEl).filter(el => currentProductId !== el.dataset.id);
        const shuffledEl = productsEl.sort(() => Math.random() - 0.5);
        const containerEl = sectionEl.querySelector('.cards-container-grid');

        containerEl.innerHTML = '';
        shuffledEl.slice(0, maxItems).forEach(el => {
          containerEl.append(el);
        })
      }
    }

    this.innerHTML = sectionEl.innerHTML;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');

          html.innerHTML = text;
          this.render(html.querySelector('product-recommendations'));
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('alp-product-info', AlpProductInfo);
customElements.define('alp-price', AlpPrice);
customElements.define('alp-product-variants-selector', AlpVariantSelector);
customElements.define('alp-product-quantity-selector', AlpQuantitySelector);
customElements.define('alp-product-form', AlpProductForm);
customElements.define('product-recommendations', ProductRecommendations);
